import { X } from 'lucide-react';
import type { DanceOff } from '../../services/danceOff';
import { winnersLabel } from '../../utils/danceOffTally';

interface DanceOffResultBannerProps {
  danceOff: DanceOff;
  onOpenVote?: () => void;
  onDismiss?: () => void;
}

export default function DanceOffResultBanner({ danceOff, onOpenVote, onDismiss }: DanceOffResultBannerProps) {
  if (danceOff.status === 'open') {
    return (
      <div className="relative mx-2 mb-3 rounded-xl bg-gradient-to-r from-pink-500 to-purple-500 p-[2px] shadow-lg z-40">
        <button
          onClick={onOpenVote}
          className="w-full text-left rounded-[10px] bg-white dark:bg-gray-900 p-4 font-semibold text-sm text-gray-900 dark:text-white"
        >
          💃 Dance-off voting is open — tap to vote
        </button>
      </div>
    );
  }

  const contestants = danceOff.winners.map((winner) => winner.contestant);
  const text = contestants.length === 0
    ? 'The dance-off ended with no votes.'
    : `🏆 ${winnersLabel(contestants)} ${contestants.length === 1 ? 'wins' : 'win'} the dance-off!`;

  return (
    <div role="status" className="animate-slide-down relative mx-2 mb-3 rounded-xl bg-gradient-to-r from-pink-500 to-amber-500 p-[2px] shadow-lg z-40">
      <div className="rounded-[10px] bg-white dark:bg-gray-900 p-4 pr-10">
        {onDismiss && (
          <button
            onClick={onDismiss}
            className="absolute top-3 right-3 p-1 rounded-full hover:bg-gray-100 dark:hover:bg-gray-800 transition-colors"
            aria-label="Dismiss"
          >
            <X className="w-4 h-4 text-gray-400" />
          </button>
        )}
        <p className="font-semibold text-gray-900 dark:text-white">{text}</p>
      </div>
    </div>
  );
}
